import React from 'react'
import ProductCard from '../ProductCard'
// Dialysis Consumables images
import dialysisConcentrates from '../../assets/Dialysis_Concentrates.webp'
import bicarbonateCartridges from '../../assets/Bicarbonate_Cartridges.webp'
import bloodlines from '../../assets/bloodlines.jpg'
import dialyzer from '../../assets/Dialyzer.avif'
import dialysisMachine from '../../assets/Dialysis_Machine.jpg'
import haemodialysisCatheter from '../../assets/Haemodialysis_Catheter.avif'
import diasafeFilters from '../../assets/Diasafe_Filters.jpg'

const data = [
    {
        id: 1,
        name: 'Dialysis Concentrates',
        imgSrc: dialysisConcentrates,
    },
    {
        id: 2,
        name: 'Bicarbonate Cartridges',
        imgSrc: bicarbonateCartridges,
    },
    {
        id: 3,
        name: 'Bloodlines',
        imgSrc: bloodlines,
    },
    {
        id: 4,
        name: 'Dialyzers',
        imgSrc: dialyzer,
    },
    {
        id: 5,
        name: 'Dialysis Machines',
        imgSrc: dialysisMachine,
    },
    {
        id: 6,
        name: 'Haemodialysis Catheter',
        imgSrc: haemodialysisCatheter,
    },
    {
        id: 7,
        name: 'Diasafe Filters',
        imgSrc: diasafeFilters,
    },
]

export default function Card7() {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {data.map((item, index) => (
                <ProductCard key={item.id} product={item} index={index} />
            ))}
        </div>
    )
}
